import arAEResource from './resources/locales/ar_AE/resource.json';
import enGBResource from './resources/locales/en_GB/resource.json';
import esESResource from './resources/locales/es_ES/resource.json';
import idIDResource from './resources/locales/id_ID/resource.json';
import jaJPResource from './resources/locales/ja_JP/resource.json';
import koKRResource from './resources/locales/ko_KR/resource.json';
import msMYResource from './resources/locales/ms_MY/resource.json';
import ptBRResource from './resources/locales/pt_BR/resource.json';
import thTHResource from './resources/locales/th_TH/resource.json';
import viVNResource from './resources/locales/vi_VN/resource.json';
import zhCNResource from './resources/locales/zh_CN/resource.json';
import zhTWResource from './resources/locales/zh_TW/resource.json';
import { TAppLanguageISOCountryCode } from './types';

export const getResourceBundle = (language: TAppLanguageISOCountryCode) => {
  switch (language) {
    case 'id_ID':
      return idIDResource;
    case 'ja_JP':
      return jaJPResource;
    case 'ko_KR':
      return koKRResource;
    case 'ms_MY':
      return msMYResource;
    case 'th_TH':
      return thTHResource;
    case 'vi_VN':
      return viVNResource;
    case 'zh_CN':
      return zhCNResource;
    case 'zh_TW':
      return zhTWResource;
    case 'ar_AE':
      return arAEResource;
    case 'es_ES':
      return esESResource;
    case 'pt_BR':
      return ptBRResource;
    default:
      return enGBResource;
  }
};
